import { DialogComponent } from '@theme/dialog';

/**
 * Account Navigation Drawer
 *
 * Extends DialogComponent to close the mobile header-drawer before opening,
 * preventing conflicting scroll-lock mechanisms between the details-based menu
 * and the dialog-based drawer.
 */
class AccountNavDrawerComponent extends DialogComponent {}

if (!customElements.get('account-nav-drawer')) {
  customElements.define('account-nav-drawer', AccountNavDrawerComponent);
}
